/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TransitionGroup = require("react-transition-group/TransitionGroup");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Icon_1 = require("./Icon");
var Checkbox_1 = require("./Checkbox");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./MultiSelect.css'); }
var Label_1 = require("./Label");
var OutsideClick_1 = require("./util/OutsideClick");
var DropdownFade_1 = require("./util/DropdownFade");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var ErrorMessage_1 = require("./ErrorMessage");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-multiSelect");
var MultiSelect = /** @class */ (function (_super) {
    tslib_1.__extends(MultiSelect, _super);
    function MultiSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visible: false
        };
        _this.handleChildChange = _this.handleChildChange.bind(_this);
        _this.toggleOptions = _this.toggleOptions.bind(_this);
        _this.hideOptions = _this.hideOptions.bind(_this);
        return _this;
    }
    MultiSelect.prototype.handleChildChange = function (event, value, childIndex) {
        if (this.props.options) {
            this.props.onChange(event, this.props.options.map(function (option, index) { return (tslib_1.__assign({}, option, { value: index === childIndex ? value : option.value })); }));
        }
    };
    MultiSelect.prototype.toggleOptions = function () {
        this.setState({
            visible: this.props.disabled ? false : !this.state.visible
        });
    };
    MultiSelect.prototype.hideOptions = function () {
        this.setState({
            visible: false
        });
    };
    MultiSelect.prototype.getCheckedOptions = function () {
        if (!this.props.options) {
            return [];
        }
        return this.props.options.reduce(function (checkedOptions, option) {
            if (option.value) {
                return checkedOptions.concat([option.label]);
            }
            return checkedOptions;
        }, []);
    };
    MultiSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, name = _a.name, disabled = _a.disabled, hasWarning = _a.hasWarning, isValid = _a.isValid, hasInfo = _a.hasInfo, errorMessage = _a.errorMessage, placeholder = _a.placeholder, options = _a.options;
        var visible = this.state.visible;
        var selectedOptions = this.getCheckedOptions();
        return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.hideOptions },
            React.createElement("div", { className: classnames(moduleClassName(), disabled && moduleClassName("disabled"), isValid && moduleClassName("isValid"), hasInfo && moduleClassName("hasInfo"), hasWarning && moduleClassName("hasWarning")) },
                React.createElement(Label_1.Label, { label: label, htmlFor: name }),
                React.createElement("button", { id: name, type: "button", className: moduleClassName("value"), onClick: this.toggleOptions },
                    selectedOptions.length ? (selectedOptions.join(", ")) : (React.createElement("span", { className: moduleClassName("placeholder") }, placeholder)),
                    React.createElement(Icon_1.Icon, { className: moduleClassName("icon"), type: "select", color: "metro-blue-tint-40", size: 0.85 })),
                React.createElement(TransitionGroup, null, visible && (React.createElement(DropdownFade_1.DropdownFade, { key: "options" },
                    React.createElement("div", { className: moduleClassName("options") }, !!options &&
                        options.map(function (option, index) {
                            var name = option.name.toString();
                            var id = option.id ? option.id.toString() : false;
                            return (React.createElement(Checkbox_1.Checkbox, { className: moduleClassName("option"), key: id || name, id: id || name, name: name, checked: option.value, disabled: option.disabled, onChange: function (event, value) {
                                    return _this.handleChildChange(event, value, index);
                                } }, option.label));
                        }))))),
                !!errorMessage && (React.createElement(ErrorMessage_1.ErrorMessage, { isInfo: hasInfo }, errorMessage)))));
    };
    MultiSelect.propTypes = {
        label: PropTypes.string,
        placeholder: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        hasWarning: PropTypes.bool,
        isValid: PropTypes.bool,
        hasInfo: PropTypes.bool,
        errorMessage: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.bool,
            disabled: PropTypes.bool,
            label: PropTypes.node.isRequired
        })),
        showImmediatly: PropTypes.bool
    };
    return MultiSelect;
}(React.Component));
exports.MultiSelect = MultiSelect;